const attachments = {
  Attachments: "Attachments",
  attachment: "attachment",
  AttachmentName: "Attachment name",
  AttachToPrescription: "Attach to {{treatmentPlanTerm}}",
  AttachSave: "Attach and save",
  AddAttachmentToLibrary: "Add attachment to my library",
  BackToListView: " Back to list view",
  Snippets: "Snippets",
  SnippetTitle: "Snippet title",
  SaveSnippet: "Save snippet",
  SnippetSaved: "Snippet saved",
  SaveToResources: "Save to resources",
  SnippetsLoading: "Snippets loading",
  ManageSnippets: "Manage snippets",
  MessageAdded: "Message added",
  MarkAsFavorite: "Mark as favorite",
  UnMarkAsFavorite: "Un-mark as favorite",
  DeleteSnippetSuccessfully: "Snippet has been deleted successfully",
  Nutrition: "Nutrition",
  Activity: "Activity",
  MyUploads: "My uploads",
  NewUpload: "New upload",
  AttachContent: "Attach content",
  Attach: "Attach",
  Replace: "Replace",
  AddButton: "Add",
  Attached: "Attached!",
  More: "More",
  FullscriptContent: "Fullscript content",
  UploadedAttachments: "Uploaded attachments",
  UploadAttachment: "Upload attachment",
  Upload: "Upload",
  Search: "search",
  SearchPlaceHolder: "Search my library...",
  SearchFullscriptContent: "Search Fullscript content...",
  NoFullscriptContentFound: "No Fullscript content found that matches the search",
  SearchContent: "Search content...",
  searchResources: "Search resources...",
  AddContentToLibrary: "Add to My library",
  RemoveContentFromLibrary: "Remove from My library",
  Resources: "Resources",
  Add: "Add content",
  LoadMore: "Load more",
  NoUploadsFound: "No uploads found.",
  UploadHelpText:
    "Upload files from your computer and you'll be able to access them here for future use.",
  NoResultsText: "No results matching",
  Added: "Added!",
  Undo: "Undo",
  Remove: "Remove",
  FavoritedAria: "favorited",
  NotFavoritedAria: "not-favorited",
  contentTypeFilter: {
    Type: "Type",
    All: "All",
    None: "None",
  },
  New: "New",
  ShowFavorites: "Show favorites",
  ShowAll: "Show all",
  OnlyShowMyLibrary: "Only show My library",
  ViewSnippetContent: "Click on a snippet to view its content",
  AddSnippetTooltip: "Add a snippet - save time with preset messages",
  AddASnippetToYourMessage: "Add a snippet to your message",
  OnlyShowFavoritedSnippets: "Only show favorite snippets",
  CreateNewSnippet: "Create new snippet",
  CreateSnippet: "Create snippet",
  Create: "Create",
  AddSnippet: "Add snippet",
  NewSnippet: "New snippet",
  SaveAsSnippet: "Save as snippet",
  SnippetAdded: "Snippet added",
  EditSnippet: "Edit snippet",
  AreYouSureDelete: "Are you sure you want to delete this snippet?",
  DeleteSnippetWithName: "Delete '{{snippetName}}'?",
  EmptySnippetPreview: "Hover over a snippet to preview it here.",
  AddSnippetToExisting: "Add to your current message?",
  DeleteSnippet: "Delete snippet?",
  AttachSnippet: "Attach snippet?",
  MaxSnippetsAllowed:
    "You may only have 25 snippets at once. Delete a snippet if you wish to create a new one.",
  MaxFavoritesAllowed: "You may only have 5 favorited snippets",
  AddToMyFavorites: "Add to my favorites",
  RemoveFromMyFavorites: "Remove from my favorites",
  YouHaveNoSnippets: "You have no snippets",
  YouHaveNoFavoritedSnippets: "You have no favorited snippets",
  ClickToAddMessage: "Click to add a message",
  YourFavouritedSnippets: "Your favorite snippets:",
  ViewAllSnippets: "View all snippets",
  AddToSnippets: "Add to snippets",
  SnippetLibrary: "Snippet library",
  YouHaveNoFavouriteSnippets: "You have no favorited snippets.",
  AddToCurrentMessage: "Add snippet",
  AlreadyContainsMessage:
    "This {{treatmentPlanTerm}} already includes a message. Do you want to replace with the selected snippet or add to it?",
  catalogDrawer: {
    myuploadsTitle: "My uploads",
    uploadButtonCTA: "Upload resource",
    add: "Add",
    remove: "Remove",
    none: "None",
    kebabLabel: "View more options",
    favoriteFilterDisabled: "My library only contains Fullscript-created content.",
    FullscriptPatientResources: {
      title: "Fullscript {{patientTerm}} resources",
      description:
        "Evidence-based guides, handouts, and infographics - written and reviewed by our Integrative Medical Advisory Team.",
    },
    ExploreAllMyUploads: "Explore all my uploads",
    ExploreAllFullscriptResources: "Explore all Fullscript resources",
    emptySearchResults: {
      title: "No results",
      description: "No results in {{authorType}}",
      clearSearch: "Clear search",
      searchAll: "Search all resources",
    },
    NoResources: {
      title: "No resources uploaded",
      description: "Add your own supporting documents to personalize your {{treatmentPlanTerm}}.",
    },
    UploadResource: {
      title: "Uploaded document",
      attachmentNoSave:
        "This file is a <1>one-time attachment</1> to your plan.<3/>It won't be saved to your resources unless you check the box below.",
      attachmentSave:
        "This file <1>will be saved</1> for you in Fullscript under the resources tab.<3/>To revert it back to a one-time attachment, uncheck the box below.",
      checkbox: "Save to resources tab",
      addToPlan: "Add to {{treatmentPlanTerm}}",
    },
  },

  sort: {
    SortBy: "Sort",
    AlphabeticalAZ: "A-Z",
    AlphabeticalZA: "Z-A",
    RecentlyAdded: "Recently added",
    Newest: "Newest",
    Oldest: "Oldest",
    FavoritesAtTop: "Favorites at top",
  },
  CantPreviewDocument: "We could not load the preview.",
  CantPreviewFile:
    "We could not load the preview. You can still view the content in a new tab by clicking the button below",
  EmptyPreview: "Click on a document to get a preview",
  EmptyDocumentPreview: "Click on an attachment to preview it here.",
  Preview: "Preview",
  OpenDocument: "Open document",
  ConfirmDocumentDelete: "Are you sure you want to delete this document",
  EditAttachment: "Edit attachment",
  Delete: "Delete",
  Cancel: "Cancel",
  Category: "Category",
  CategorySelector: "Category selector",
  SaveToYourUploads: "Save to your uploads",
  SavedToUploadsSuccess: "Saved to your uploads",
  AllCategories: "All categories",
  Clear: "Clear",
} as const;

export { attachments };
